"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CheckBox;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactNative = require("react-native");
var _excluded = ["value", "onPress", "disabled", "checkedColor", "tickColor", "borderColor", "disabledBorderColor", "style"];
function CheckBox(_ref) {
  var value = _ref.value,
    onPress = _ref.onPress,
    disabled = _ref.disabled,
    checkedColor = _ref.checkedColor,
    _ref$tickColor = _ref.tickColor,
    tickColor = _ref$tickColor === void 0 ? '#FFFFFF' : _ref$tickColor,
    borderColor = _ref.borderColor,
    _ref$disabledBorderCo = _ref.disabledBorderColor,
    disabledBorderColor = _ref$disabledBorderCo === void 0 ? '#767676' : _ref$disabledBorderCo,
    style = _ref.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    activeOpacity: 0.8,
    onPress: onPress,
    disabled: disabled,
    style: [styles.container, {
      backgroundColor: value ? disabled ? '#A0A0A0' : checkedColor : disabled ? '#EDEBEB' : 'white',
      borderColor: disabled ? disabledBorderColor : value ? checkedColor : borderColor
    }, style]
  }, rest), value && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.tickWrapper
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 4.5L3.5 7L9 1",
    stroke: tickColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 18,
    // Slightly larger for better web accessibility
    width: 18,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 3,
    cursor: 'pointer' // Web-specific: shows the hand icon
  },
  tickWrapper: {
    justifyContent: 'center',
    alignItems: 'center'
  }
});
CheckBox.propTypes = {
  value: _propTypes["default"].bool.isRequired,
  onPress: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  checkedColor: _propTypes["default"].string,
  tickColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  disabledBorderColor: _propTypes["default"].string
};